module.exports = __webpack_public_path__ + "media/common/img/bart_zoni-abcc27e868330fbfca21e77f20f3c59f.jpg";